import React from "react";
export const OrderTabContext = React.createContext();